import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, Router} from '@angular/router';
import {PrlPagesService} from './prl-pages.service';
import {Observable} from 'rxjs';
import {map, tap} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class PrlPageGuard implements CanActivate {

    constructor(
        private pagesService: PrlPagesService,
        private router: Router
    ) {}

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | boolean {
        const pageName = route.data['pageName'] as string;

        if (!pageName) {
            return true;
        }

        return this.pagesService.ensurePagesLoaded().pipe(
            map(loaded => loaded && this.pagesService.isPageEnabled(pageName)),
            tap(canActivate => {
                if (!canActivate) {
                    this.router.navigate(['/dashboard']);
                }
            })
        );
    }
}